// Centralized Supabase configuration
// Uses environment variable with fallback to production project ID
export const SUPABASE_PROJECT_ID = "kwvlguzoxycjvlsvfzgj";

export const SUPABASE_FUNCTIONS_URL = 
  `https://${SUPABASE_PROJECT_ID}.supabase.co/functions/v1`;

export const SUPABASE_BASE_URL = 
  `https://${SUPABASE_PROJECT_ID}.supabase.co`;

// Storage key for auth tokens
export const SUPABASE_STORAGE_KEY = `sb-${SUPABASE_PROJECT_ID}-auth-token`;
